import React from 'react';
import { Card, Collapse } from 'react-bootstrap';

import { render_marked_finding } from '../utils/HiddenText';

function Weaknesses({
	analysis_results,
	show_weaknesses,
	set_show_weaknesses
}){

	const render_weaknesses_section = ()=>{
		const data = analysis_results.weaknesses.weaknesses_list;
		if(!data){
			return;
		}

		return(
			<Card className="analysis-results-card weaknesses-card">
				<h3 className="weaknesses-title" onClick={()=>set_show_weaknesses(!show_weaknesses)} style={{cursor:'pointer'}}>
					Weaknesses {show_weaknesses ? "▲" : "▼"}
				</h3>
				<p className="weaknesses-desc">
					Areas where the page falls short and may reduce AI-search performance.
				</p>

				<Collapse in={show_weaknesses}>
					<div className="weaknesses-list">
						{data.map((finding, index)=>{
							return(
								<div key={index} className="weaknesses-text-box">
									{render_marked_finding(finding, analysis_results)}
								</div>
							);
						})}
					</div>
				</Collapse>
			</Card>
		);
	};

	if(!analysis_results || !analysis_results.weaknesses){
		return null;
	}

	return render_weaknesses_section();
}

export default Weaknesses;
